// extracted by mini-css-extract-plugin
export default {"productCarousel":"j1-z"};